import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "app/_services/authentication.service";
import { AdminApiService } from "app/services/admin-api.service";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { AlertsService } from "app/services/alerts.service";

@Component({
    selector: "app-page-header",
    templateUrl: "./header.component.html",
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class PageHeaderComponent implements OnInit {
  screenWidth: number;
  fsAppsUser;
  user;
  adminAccess = false;
  userManagementAccess = false;
  siteSettingsAccess = false;
  isLoading = false;
  isAdminView: boolean = false;
  alerts = [];
  adminAlerts = [];

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly adminApiService: AdminApiService,
    private readonly router: Router,
    private readonly alertsService: AlertsService,
    ) {}

  ngOnInit(): void {
    this.alertsService.getPublicAlerts().subscribe((res: any) => {
      this.alerts = res;
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url.includes('/admin')) {
        this.isAdminView = true;
        this.authenticationService.user.subscribe((user: any) => {
          this.fsAppsUser = user;
          if (user) {
            this.adminApiService.getUser(this.fsAppsUser.id).subscribe(u => {
              this.user = u;
              this.adminAccess = this.authenticationService.checkIfAdminAccess(this.user);
              this.userManagementAccess = this.authenticationService.checkIfUserManagementAccess(this.user);
              this.siteSettingsAccess = this.authenticationService.checkIfSupportUser(this.user);
              if (this.adminAccess) {
                this.setAdminAlerts();
              }
            })
          }
        });
      } else {
        this.isAdminView = false;
      }
    });
  }

  setAdminAlerts() {
    this.alertsService.getAdminAlerts().subscribe((res: any) => {
      this.adminAlerts = res;
    });
  }

  login(): any {
    this.authenticationService.login();
  }

  logout(): any {
    this.isLoading = true;
    this.authenticationService.logout().subscribe((result: any) => {
      this.isLoading = false;
      this.adminAccess = false;
      this.userManagementAccess = false;
      this.siteSettingsAccess = false;
      this.user = null;
    }, error => this.isLoading = false);
  }
}
